import { create } from "zustand";

const useShowUsers = create<ShowUsersStoreStateType>()((set, get) => ({
  showUsers: true,
  setShowUsers: (newValue: boolean) => {
    set({ showUsers: newValue });
  },
  toggleShowUSers: () => {
    set({ showUsers: !get().showUsers });
  },
}));

export default useShowUsers;
